
import { defineComponent } from 'vue';

import Form from '@/shared/mixins/Form';
import { adService } from '@/ad/AdService';
import { required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import config from '@/shared/constants/config';

export default defineComponent({
  name: 'ComplaintInsert',
  mixins: [Form],
  emits: ['close'],
  setup() {
    return { v$: useVuelidate() };
  },
  props: {
    adId: Number,
    adFrontId: String,
    title: String,
  },
  data() {
    return {
      domain: config.DOMAIN,
      generalTermsUrl: config.GENERAL_TERMS_URL,
      form: {
        message: '',
      },
    };
  },
  validations() {
    return {
      form: {
        message: { required },
      },
    };
  },
  methods: {
    onEdit() {
      this.isSuccess = false;
      this.isError = false;
    },
    async send() {
      if (!this.validate() || !this.adId) return;

      try {
        await adService.addComplaint({ adId: this.adId, message: this.form.message });
        this.success();
      } catch (error) {
        this.handleApiError(error);
      }
    },
    close() {
      this.$emit('close');
    },
  },
});
